import _slicedToArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["onConfirm", "disableButton", "minW", "buttonText", "modalTitle", "modalMessage", "confirmButtonText", "cancelButtonText"],
    _excluded2 = ["onConfirm", "modalTitle", "modalMessage", "confirmButtonText", "cancelButtonText"],
    _excluded3 = ["isActive"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, IconButton, Input, Modal, ModalContent, ModalFooter, ModalHeader, ModalOverlay, NumberInput, NumberInputField, Text, forwardRef, useDisclosure, useToken } from '@chakra-ui/react';
import { Button, Tooltip } from '@cofit/components';
import _ from 'lodash';
import * as R from 'ramda';
import { useCallback, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { components } from 'react-select';
import dataTestID from '../../constants/DataTestIndex';
import drugsConstant from '../../constants/drugs';
import ConfirmModal from '../common/ConfirmModal';
import { Select } from '../common/Form/Select';
import { TurnsIntoToVideoIcon, VideoIcon } from '../common/Icons';
import TitleHeader from '../common/TitleHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var FrequencySelector = function FrequencySelector(props) {
  return /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({
    className: "w-28",
    options: drugsConstant.frequency_option
  }, props), {}, {
    e2eid: "Table_TableCell_Select"
  }));
};
export var InputSelector = function InputSelector(_ref) {
  var max = _ref.max,
      defaultValue = _ref.defaultValue,
      _onChange = _ref.onChange,
      quarterInput = _ref.quarterInput,
      _ref$additionalValues = _ref.additionalValues,
      additionalValues = _ref$additionalValues === void 0 ? [] : _ref$additionalValues,
      error = _ref.error,
      isDisabled = _ref.isDisabled,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type;
  var options = useMemo(function () {
    var arr = _.range(0, max, 1).concat(additionalValues);

    arr = quarterInput ? [0.125, 0.25, 0.5].concat(arr) : arr;
    return arr.sort(function (a, b) {
      return a - b;
    }).map(function (i) {
      return {
        label: i,
        value: i
      };
    });
  }, [quarterInput, max, additionalValues]);
  return /*#__PURE__*/_jsx(Select, {
    className: "w-28",
    isInvalid: !!(error !== null && error !== void 0 && error.message),
    isDisabled: isDisabled,
    value: {
      label: defaultValue,
      value: defaultValue
    },
    onChange: function onChange(option) {
      if (!option) {
        return;
      }

      _onChange(option.value);
    },
    options: options,
    components: {
      Input: function Input(props) {
        return /*#__PURE__*/_jsx(components.Input, _objectSpread(_objectSpread({}, props), {}, {
          type: type
        }));
      }
    } // {...rest}
    ,
    e2eid: "Table_TableCell_Select_1"
  });
};
export var DisabledDeleteButton = function DisabledDeleteButton() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(Box, {
    e2eid: "Table_TableCell_Box",
    children: /*#__PURE__*/_jsx(Button, {
      isDisabled: true,
      variant: "link",
      fontWeight: "normal",
      size: "sm",
      p: "1",
      e2eid: "Table_TableCell_Button",
      children: t('common:normal.remove', '移除')
    })
  });
};
export var DeleteButton = function DeleteButton(_ref2) {
  var row = _ref2.row,
      onDeleteConfirm = _ref2.onDeleteConfirm;

  var _useDisclosure = useDisclosure(),
      isOpen = _useDisclosure.isOpen,
      onOpen = _useDisclosure.onOpen,
      onClose = _useDisclosure.onClose;

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      e2eid: "Table_TableCell_Box",
      children: /*#__PURE__*/_jsx(Button, {
        onClick: onOpen,
        variant: "link",
        justifyContent: "flex-start",
        e2eid: "Table_TableCell_Button",
        children: t('common:normal.remove', '移除')
      })
    }), /*#__PURE__*/_jsxs(Modal, {
      isOpen: isOpen,
      onClose: onClose,
      e2eid: "Table_TableCell_Modal",
      children: [/*#__PURE__*/_jsx(ModalOverlay, {
        e2eid: "Table_TableCell_ModalOverlay"
      }), /*#__PURE__*/_jsxs(ModalContent, {
        "data-test": dataTestID.generalTable.DeleteBtnModal,
        e2eid: "Table_TableCell_ModalContent",
        children: [/*#__PURE__*/_jsx(ModalHeader, {
          e2eid: "Table_TableCell_ModalHeader",
          children: /*#__PURE__*/_jsx(TitleHeader, {
            e2eid: "Table_TableCell_TitleHeader",
            children: t('common:normal.areYouSureToDelete', '是否確定要刪除？')
          })
        }), /*#__PURE__*/_jsxs(ModalFooter, {
          w: "full",
          justifyContent: "center",
          e2eid: "Table_TableCell_ModalFooter",
          children: [/*#__PURE__*/_jsx(Button, {
            variant: "outline",
            mr: 3,
            onClick: onClose,
            e2eid: "Table_TableCell_Button",
            children: t('common:button.cancel', '取消')
          }), /*#__PURE__*/_jsx(Button, {
            onClick: function onClick() {
              onDeleteConfirm(row);
              onClose();
            },
            "data-test": dataTestID.generalTable.ConfirmDeleteButton,
            e2eid: "Table_TableCell_Button_13",
            children: t('common:button.confirm', '確認')
          })]
        })]
      })]
    })]
  });
};
export var TaskButton = forwardRef(function (_ref3, ref) {
  var _ref3$onConfirm = _ref3.onConfirm,
      onConfirm = _ref3$onConfirm === void 0 ? function () {} : _ref3$onConfirm,
      _ref3$disableButton = _ref3.disableButton,
      disableButton = _ref3$disableButton === void 0 ? false : _ref3$disableButton,
      _ref3$minW = _ref3.minW,
      minW = _ref3$minW === void 0 ? '' : _ref3$minW,
      _ref3$buttonText = _ref3.buttonText,
      buttonText = _ref3$buttonText === void 0 ? '' : _ref3$buttonText,
      _ref3$modalTitle = _ref3.modalTitle,
      modalTitle = _ref3$modalTitle === void 0 ? '' : _ref3$modalTitle,
      _ref3$modalMessage = _ref3.modalMessage,
      modalMessage = _ref3$modalMessage === void 0 ? '' : _ref3$modalMessage,
      _ref3$confirmButtonTe = _ref3.confirmButtonText,
      confirmButtonText = _ref3$confirmButtonTe === void 0 ? '' : _ref3$confirmButtonTe,
      _ref3$cancelButtonTex = _ref3.cancelButtonText,
      cancelButtonText = _ref3$cancelButtonTex === void 0 ? '' : _ref3$cancelButtonTex,
      rest = _objectWithoutProperties(_ref3, _excluded);

  var _useDisclosure2 = useDisclosure(),
      isOpen = _useDisclosure2.isOpen,
      onOpen = _useDisclosure2.onOpen,
      onClose = _useDisclosure2.onClose;

  var handleApply = useCallback(function () {
    onConfirm();
    onClose();
  }, [onConfirm, onClose]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      e2eid: "Table_TableCell_Box",
      children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
        ref: ref,
        px: "1",
        minW: minW,
        isDisabled: disableButton,
        onClick: onOpen
      }, rest), {}, {
        e2eid: "Table_TableCell_Button",
        children: buttonText
      }))
    }), /*#__PURE__*/_jsx(ConfirmModal, {
      isOpen: isOpen,
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
      title: modalTitle,
      message: modalMessage,
      onClose: onClose,
      onApply: handleApply,
      e2eid: "Table_TableCell_ConfirmModal"
    })]
  });
});
export var TaskIconButton = function TaskIconButton(_ref4) {
  var _ref4$onConfirm = _ref4.onConfirm,
      onConfirm = _ref4$onConfirm === void 0 ? function () {} : _ref4$onConfirm,
      _ref4$modalTitle = _ref4.modalTitle,
      modalTitle = _ref4$modalTitle === void 0 ? '' : _ref4$modalTitle,
      modalMessage = _ref4.modalMessage,
      _ref4$confirmButtonTe = _ref4.confirmButtonText,
      confirmButtonText = _ref4$confirmButtonTe === void 0 ? '' : _ref4$confirmButtonTe,
      _ref4$cancelButtonTex = _ref4.cancelButtonText,
      cancelButtonText = _ref4$cancelButtonTex === void 0 ? '' : _ref4$cancelButtonTex,
      rest = _objectWithoutProperties(_ref4, _excluded2);

  var _useDisclosure3 = useDisclosure(),
      isOpen = _useDisclosure3.isOpen,
      onOpen = _useDisclosure3.onOpen,
      onClose = _useDisclosure3.onClose;

  var handleApply = useCallback(function () {
    onConfirm();
    onClose();
  }, [onConfirm, onClose]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      e2eid: "Table_TableCell_Box",
      children: /*#__PURE__*/_jsx(IconButton, _objectSpread(_objectSpread({
        "aria-label": "task",
        onClick: onOpen,
        colorScheme: "brandScheme"
      }, rest), {}, {
        e2eid: "Table_TableCell_IconButton"
      }))
    }), /*#__PURE__*/_jsx(ConfirmModal, {
      isOpen: isOpen,
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
      title: modalTitle,
      message: modalMessage,
      onClose: onClose,
      onApply: handleApply,
      e2eid: "Table_TableCell_ConfirmModal"
    })]
  });
};
export var CustomInput = function CustomInput(_ref5) {
  var defaultValue = _ref5.defaultValue,
      onChange = _ref5.onChange,
      _ref5$isString = _ref5.isString,
      isString = _ref5$isString === void 0 ? false : _ref5$isString,
      isInvalid = _ref5.isInvalid,
      _ref5$type = _ref5.type,
      type = _ref5$type === void 0 ? 'text' : _ref5$type,
      _ref5$w = _ref5.w,
      w = _ref5$w === void 0 ? 'full' : _ref5$w,
      _ref5$minW = _ref5.minW,
      minW = _ref5$minW === void 0 ? 'auto' : _ref5$minW,
      _ref5$withTooltip = _ref5.withTooltip,
      withTooltip = _ref5$withTooltip === void 0 ? false : _ref5$withTooltip,
      _ref5$isDisabled = _ref5.isDisabled,
      isDisabled = _ref5$isDisabled === void 0 ? false : _ref5$isDisabled,
      _ref5$min = _ref5.min,
      min = _ref5$min === void 0 ? 0 : _ref5$min,
      max = _ref5.max;

  var _useState = useState(defaultValue),
      value = _useState[0],
      setValue = _useState[1];

  var defaultRef = useRef();
  var handleKeyUp = useCallback(function (event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      event.target.blur();
      defaultRef.current.blur();
    }
  }, []);
  var handleBlur = useCallback(function () {
    if (isString) {
      onChange(value);
    } else {
      onChange(parseInt(value) || 0);
    }
  }, [onChange, isString, value]);
  var InputComp = isString ? /*#__PURE__*/_jsx(Input, {
    w: w,
    minW: minW,
    px: "2",
    isInvalid: isInvalid,
    ref: defaultRef,
    onKeyUp: handleKeyUp,
    type: type,
    onBlur: handleBlur,
    value: value,
    onChange: R.pipe(R.path(['target', 'value']), setValue),
    isDisabled: isDisabled,
    e2eid: "Table_TableCell_Input"
  }) : /*#__PURE__*/_jsx(NumberInput, {
    ref: defaultRef,
    w: w,
    minW: minW,
    isInvalid: isInvalid,
    keepWithinRange: true,
    min: min,
    max: max,
    onKeyUp: handleKeyUp,
    onBlur: handleBlur,
    value: value,
    onChange: setValue,
    isDisabled: isDisabled,
    e2eid: "Table_TableCell_NumberInput",
    children: /*#__PURE__*/_jsx(NumberInputField, {
      e2eid: "Table_TableCell_NumberInputField"
    })
  });
  return withTooltip ? /*#__PURE__*/_jsx(Tooltip, {
    label: value,
    e2eid: "Table_TableCell_Tooltip",
    children: InputComp
  }) : InputComp;
};
export var CustomSelect = function CustomSelect(_ref6) {
  var value = _ref6.value,
      options = _ref6.options,
      onChange = _ref6.onChange,
      _ref6$isDisabled = _ref6.isDisabled,
      isDisabled = _ref6$isDisabled === void 0 ? false : _ref6$isDisabled;

  var _useToken = useToken('zIndices', ['dropdown']),
      _useToken2 = _slicedToArray(_useToken, 1),
      zIndexDropdown = _useToken2[0];

  var selectedOption = R.find(R.propEq(value, 'value'))(options);
  return /*#__PURE__*/_jsx(Select, {
    menuPortalTarget: document.body,
    styles: {
      menuPortal: function menuPortal(base) {
        return _objectSpread(_objectSpread({}, base), {}, {
          zIndex: zIndexDropdown
        });
      }
    },
    isDisabled: isDisabled,
    className: "w-28",
    value: selectedOption,
    options: options,
    onChange: onChange,
    e2eid: "Table_TableCell_Select"
  });
};
export var VideoButton = function VideoButton(_ref7) {
  var _ref7$isActive = _ref7.isActive,
      isActive = _ref7$isActive === void 0 ? false : _ref7$isActive,
      rest = _objectWithoutProperties(_ref7, _excluded3);

  return isActive ? /*#__PURE__*/_jsx(IconButton, _objectSpread(_objectSpread({
    "aria-label": "videoCall",
    icon: /*#__PURE__*/_jsx(VideoIcon, {
      fill: "orange.brand",
      e2eid: "Table_TableCell_VideoIcon"
    }),
    colorScheme: "brandScheme"
  }, rest), {}, {
    e2eid: "Table_TableCell_IconButton"
  })) : /*#__PURE__*/_jsx(IconButton, _objectSpread(_objectSpread({
    "aria-label": "turnsIntoVideoCall",
    icon: /*#__PURE__*/_jsx(TurnsIntoToVideoIcon, {
      fill: "gray.300",
      e2eid: "Table_TableCell_TurnsIntoToVideoIcon"
    })
  }, rest), {}, {
    e2eid: "Table_TableCell_IconButton"
  }));
};
export var renderTooltipCell = function renderTooltipCell(info) {
  return /*#__PURE__*/_jsx(Tooltip, {
    label: info.getValue(),
    e2eid: "Table_TableCell_Tooltip",
    children: /*#__PURE__*/_jsx(Text, {
      isTruncated: true,
      e2eid: "Table_TableCell_Text",
      children: info.getValue()
    })
  });
};
export var renderEmptyPlaceholderCell = function renderEmptyPlaceholderCell(info) {
  return /*#__PURE__*/_jsx(Text, {
    e2eid: "Table_TableCell_Text_31",
    children: info.getValue() || '-'
  });
};
export function renderGenderCell(t) {
  return function GenderCell(info) {
    var gender = info.getValue();
    return /*#__PURE__*/_jsx(Text, {
      color: "inherit",
      e2eid: "Table_TableCell_Text_32",
      children: t("common:gender.".concat(gender), '')
    });
  };
}